const menu = {
  'menu.company': 'Company',
  'menu.contactUs': 'Contact Us',
  'menu.privacyPolicy': 'Privacy Policy',
  'menu.terms': 'Terms & Conditions',
  'menu.howToMakeGoodApp': 'How to make a good application',
  'menu.covid': 'Covid-19',
  'menu.aboutTefl': 'About TEFL',
  'menu.lifeInBarcelona': 'Life in Barcelona',
  'menu.lifeInSeville': 'Life in Seville',
  'menu.aboutUsFooter': 'About us',
  'menu.spanishCourses': 'Spanish courses',

  'menu.helpCenter': 'Help center',
};

export default menu;
